import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import produce from 'immer';
import * as api from 'app/api';

const POST_ORDER = 'orders/POST_ORDER';
const postOrderAction = createAction(POST_ORDER, api.postOrder);

const POST_ORDER_TRANSACTION = 'orders/POST_ORDER_TRANSACTION';
const postOrderTransactionAction = createAction(POST_ORDER_TRANSACTION, api.postOrderTransaction);

const POST_VIRTUAL_ACCOUNT = 'orders/POST_VIRTUAL_ACCOUNT';
const postVirtualAccount = createAction(POST_VIRTUAL_ACCOUNT, ({ transactionId, data }) => api.postVirtualAccountPayment(transactionId, data));

const GET_ORDER = 'orders/GET_ORDER';
const getOrderAction = createAction(GET_ORDER, api.getOrder);

const GET_ORDER_TRANSACTION = 'orders/GET_ORDER_TRANSACTION';
const getOrderTransactionAction = createAction(GET_ORDER_TRANSACTION, api.getTransaction);

const initialState = {
	order: null,
	orderTransaction: null,
};

export const ordersActions = {
	postOrderAction,
	postOrderTransactionAction,
	postVirtualAccount,
	getOrderAction,
	getOrderTransactionAction,
};

export default handleActions(
	{
		...pender({
			type: GET_ORDER,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.order = data;
				}),
		}),
		...pender({
			type: GET_ORDER_TRANSACTION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.orderTransaction = data;
				}),
		}),
	},
	initialState,
);
